module.exports = __webpack_public_path__ + "front/img/p4.9098b8d7.png";